import gql from "graphql-tag";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {useFastlyQuery} from "@repo/data-gql";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    videoByReadableIdType,
    videoDataYoutubeIdType,
} from "./__graphql-types__/index.ts";
import type {videoDataYoutubeId} from "./__graphql-types__/videoDataYoutubeId.ts";

export const VIDEO_BY_READABLE_ID_QUERY: GqlOperation<
    videoByReadableIdType["response"],
    videoByReadableIdType["variables"]
> = gqlOp(gql`
    query videoByReadableId($videoId: String!) {
        video(id: $videoId) {
            id
            title
            youtubeId
            contentId
        }
    }
`);

export const VIDEO_BY_YOUTUBE_ID_QUERY: GqlOperation<
    videoDataYoutubeIdType["response"],
    videoDataYoutubeIdType["variables"]
> = gqlOp(gql`
    query videoDataYoutubeId($videoId: String!) {
        video: videoByYoutubeId(youtubeId: $videoId) {
            id
            title
            youtubeId
            contentId
        }
    }
`);

const queries = {
    YOUTUBE_ID: VIDEO_BY_YOUTUBE_ID_QUERY,
    READABLE_ID: VIDEO_BY_READABLE_ID_QUERY,
} as const;

export const useVideo = (
    id: string,
    kind: "YOUTUBE_ID" | "READABLE_ID",
): Result<videoDataYoutubeId> => {
    return useFastlyQuery(queries[kind], {
        variables: {
            videoId: id,
        },
    });
};
